// extracted by mini-css-extract-plugin
module.exports = {"text":"var(--text)","number":"var(--number)","iconcolor":"var(--icon)"};